import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './polyfills/reactDomShim';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { captureQrContextFromWindow } from './utils/registerContext';
import { persistWsTokenFromWindow } from './utils/wsToken';

captureQrContextFromWindow();
persistWsTokenFromWindow();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

reportWebVitals();
